import ZoomAttendanceTable from './ZoomAttendanceTable';

export default ZoomAttendanceTable;
